import styled from "styled-components/native";

export const RESTAURANT_CARD_GAP = 30;
export const RESTAURANT_CARD_GAP_MOBILE = 18;

export const ItemContainer = styled.View<{ hasGap?: boolean, isMobile?: boolean }>`
    margin-right: ${({ hasGap, isMobile }) => (hasGap && !isMobile ? RESTAURANT_CARD_GAP : 0)}px;
    margin-bottom: ${({ isMobile }) => (isMobile ? RESTAURANT_CARD_GAP_MOBILE : RESTAURANT_CARD_GAP)}px;
`;
